import React, { useEffect } from 'react';
import { startCase } from 'lodash';
import { AppContent, Tabs } from '@common/components';
import { ComplianceTable } from '@onboarding/components';
import { useNavigate, useParams } from '@common/hooks';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';

export function SupplierCompliancePage() {
  const navigate = useNavigate();
  const { tabKey } = useParams<{ tabKey: string }>();

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Compliance', path: '/works/supplier/compliance' },
      {
        name: startCase(tabKey),
        path: `/works/supplier/compliance/${tabKey}`,
      },
    ]);
  }, [tabKey]);

  return (
    <>
      <AppContent className="supplier-compliance-page">
        <Tabs
          defaultActiveKey={tabKey || 'assignment'}
          onTabClick={(key: string) =>
            navigate(`/works/supplier/compliance/${key}`, { replace: true })
          }
        >
          <Tabs.Pane tab="expired" key="expired">
            <ComplianceTable
              entity="supplier"
              defaultFilter={{
                assignmentState: ['onboarding', 'cleared', 'working'],
                expired: true,
              }}
              defaultOrder={{
                complianceState: 'ascend',
                expiresOn: 'ascend',
              }}
              filterKey="complianceTableExpired"
            />
          </Tabs.Pane>
          <Tabs.Pane tab="expiring" key="expiring">
            <ComplianceTable
              entity="supplier"
              defaultFilter={{
                assignmentState: ['onboarding', 'cleared', 'working'],
                expiringSoon: true,
              }}
              defaultOrder={{
                complianceState: 'ascend',
                expiresOn: 'ascend',
              }}
              filterKey="complianceTableExpiring"
            />
          </Tabs.Pane>
        </Tabs>
      </AppContent>
    </>
  );
}
